import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggregatedIncidentsTimeResponse } from '@/api/routes/incidents/types';

import { fetchIncidentsAggregateTime } from './actionCreators';

interface InitialState {
  aggregatedIncidentsTime: AggregatedIncidentsTimeResponse [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggregatedIncidentsTime: [],
  isLoading: false,
  error: '',
};

export const aggregatedIncidentsTimeSlice = createSlice({
  name: 'aggregatedIncidentsTime',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchIncidentsAggregateTime.fulfilled.type]:
      (state, action: PayloadAction<AggregatedIncidentsTimeResponse []>) => {
        state.isLoading = false;
        state.error = '';
        state.aggregatedIncidentsTime = action.payload;
      },
    [fetchIncidentsAggregateTime.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchIncidentsAggregateTime.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggregatedIncidentsTimeSlice.reducer;
